"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocation = void 0;
const react_1 = require("react");
const router_1 = require("next/router");
function useLocation() {
    var _a, _b;
    const [pathname, setPathname] = (0, react_1.useState)((_a = global.window) === null || _a === void 0 ? void 0 : _a.location.pathname);
    const [search, setSearch] = (0, react_1.useState)((_b = global.window) === null || _b === void 0 ? void 0 : _b.location.search);
    const router = (0, router_1.useRouter)();
    const listenToPopstate = () => {
        setPathname(window.location.pathname);
        setSearch(window.location.search);
    };
    (0, react_1.useEffect)(() => {
        router.events.on('routeChangeComplete', listenToPopstate);
        return () => {
            router.events.off('routeChangeComplete', listenToPopstate);
        };
    }, []);
    return {
        pathname,
        search,
    };
}
exports.useLocation = useLocation;
